import React from 'react';
import './Card.css';

function Card({
  children,
  padding = 'md',
  interactive = false,
  as: Tag = 'div',
  className = '',
  onClick,
  ...rest
}) {
  const classes = [
    'ui-card',
    `ui-card--pad-${padding}`,
    interactive ? 'ui-card--interactive' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <Tag
      className={classes}
      onClick={onClick}
      role={interactive && onClick ? 'button' : undefined}
      tabIndex={interactive && onClick ? 0 : undefined}
      onKeyDown={(e) => {
        if (interactive && onClick && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          onClick(e);
        }
      }}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export default Card;
